module.exports = __webpack_public_path__ + "static/media/clothes.06e11ea7.png";